import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M76.361 59.72L52.306 35.667a3.148 3.148 0 0 0-4.454 0c-.027.027-.035.064-.061.092s-.068.036-.1.064L23.639 59.88a3.149 3.149 0 1 0 4.454 4.453l21.986-21.986 21.828 21.826a3.149 3.149 0 0 0 4.454-4.453z'

const IconCaretUp: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconCaretUp
